import React from 'react';
import GameActions from '../actions/GameActions';
import GameStore from '../stores/GameStore';
import LevelActions from '../actions/LevelActions';
import LevelSelection from './LevelSelection';

class StartScreen extends React.Component {

  componentDidMount() {
    this.props.sound.play('menu');
  }

  componentWillUnmount() {
    this.props.sound.stop('menu');
  }

  render() {
    return (
      <div id="game-menu">
        <div className="menu-title">

          <span className="c1">A</span>
          <span className="c2">d</span>
          <span className="c3">v</span>
          <span className="c4">e</span>
          <span className="c5">n</span>
          <span className="c6">t</span>
          <span className="c1">u</span>
          <span className="c2">r</span>
          <span className="c3">e</span>
          <span className="c4">s </span>
           
          <span className="c5">o</span>
          <span className="c6">f </span>
            
          <span className="c1">F</span>
          <span className="c2">i</span>
          <span className="c3">n</span>
          <span className="c4">n</span>
        </div>
        
        <div className="player-selection">
          <div className="player-option-l">
            <button className="menu-item" onClick={this.handleMenuStartM}>
              <img src="tiles/player/male/Idle_1.png" alt="male avatar"/>
              <p>Play as Finn</p>
            </button>
          </div>
          <div className="player-option-r">
            <button className="menu-item" onClick={this.handleMenuStartF}>
              <img src="tiles/player/female/Idle_1.png" alt="female avatar" />
              <p>Play as Cheryl</p>
            </button>
          </div>
        </div>

        <LevelSelection />

        <p>Highscore: {GameStore.highscore}</p>
      </div>
    );
  }

  handleMenuStartF = () => {
    GameActions.setCharacter('female');
    GameActions.startGame();
    LevelActions.loadLevel(0);
  }

  handleMenuStartM = () => {
    GameActions.setCharacter('male');
    GameActions.startGame();
    LevelActions.loadLevel(0);
  }

}

export default StartScreen;